(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3HandicapHistory', {
            templateUrl: 'app/shared/handicap-history/handicap-history.component.html',
            controller: HandicapHistoryComponent,
            bindings: {
                individualId: '<',
                offsetInDays: '<',
                history: '<'
            }
        });

    var gettext = angular.identity;

    HandicapHistoryComponent.$inject = ['$filter', '$scope', 'Member', 'memberAdminResources', 'handicapHistoryFilters', 'alert'];
    function HandicapHistoryComponent($filter, $scope, Member, resources, handicapHistoryFilters, alert) {
        // ** Variables
        var ctrl = this,
            handicapFilter = $filter('handicap'),
            dateFilter = $filter('date');

        // ** Properties
        ctrl.individualId = null;
        ctrl.offsetInDays = null;
        ctrl.history = null;
        ctrl.offsetInDaysList = handicapHistoryFilters;

        // ** Properties (chart)
        ctrl.labels = [];
        ctrl.data = [];
        ctrl.series = [];
        ctrl.datasetOverride = { fill: false, label: 'Handicap', borderColor: 'rgba(151, 187, 205, 1)', backgroundColor: 'rgba(151, 187, 205, 0.3)' };
        ctrl.options = {
            fill: false,
            scales: {
                yAxes: [{ ticks: { callback: handicapAxisLabel } }],
                xAxes: [{ ticks: { callback: dateAxisLabel } }]
            },
            tooltips: { callbacks: { label: tooltipLabel } }
        };

        // Methods
        ctrl.$onInit = init;

        ///////////////////////////////////////////

        // Core
        function init() {
            $scope.$watch('$ctrl.offsetInDays', refresh);
            $scope.$watch('$ctrl.history', setChart);
        }
        function refresh(newVal, oldVal) {
            var individualId = ctrl.individualId,
                offsetInDays = ctrl.offsetInDays;

            if (newVal !== oldVal) {
                Member.getHandicapHistory({ id: individualId, offsetInDays: offsetInDays }, success, error, true);
            }

            function success(history) {
                ctrl.history = history;
            }
            function error() {
                alert.error(resources.handicapHistoryFailed);
            }
        }

        function setChart() {
            var history = ctrl.history;
            ctrl.labels = history.map(pluck('date'));

            var handicap = history.map(pluck('handicap'));
            var lowhandi = history.map(pluck('lowHandicap'));

            ctrl.data = [handicap, lowhandi];
            ctrl.series = ['Handicap History'];
        }

        // Helpers
        function pluck(field) {
            return function (dataItem) {
                return dataItem[field];
            }
        }

        function handicapAxisLabel(value, index, values) {
            return handicapFilter(value);
        }

        function dateAxisLabel(value, index, values) {
            return dateFilter(value, 'shortDate');
        }

        function tooltipLabel(tooltipItem, data) {
            var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
            return datasetLabel + ': ' + handicapFilter(tooltipItem.yLabel);
        }
    }

})();